import { render } from "./desktopPostBuilder.vue?vue&type=template&id=6ff5775b&scoped=true"
import script from "./desktopPostBuilder.vue?vue&type=script&lang=js"
export * from "./desktopPostBuilder.vue?vue&type=script&lang=js"

import "./desktopPostBuilder.vue?vue&type=style&index=0&id=6ff5775b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff5775b"]])

export default __exports__